import { parseUrl } from './parse-url';

export const RETURN_PARAM = 'url';

const RETURN_ROUTE = /^\/concursos(\?[A-Za-z0-9_=&-]{1,300})?$/;

export function readReturnUrl(value: string | null, origin: string): string | null {
  const url = value === null ? null : parseUrl(value);
  if (url === null) {
    return null;
  }

  const route = `${url.pathname}${url.search}`;
  return url.origin === origin && RETURN_ROUTE.test(route) ? `${url.origin}${route}` : null;
}

export function toReturnUrl(route: string, origin: string): string {
  return new URL(route, origin).href;
}
